export default __webpack_public_path__ + "static/media/RadicalRocks_08.e114b983.png";